'use client';

import { useState, useEffect, useCallback } from 'react';
import {
  getAllPresets,
  savePreset,
  deletePreset,
  type CalendarPreset,
} from '@/lib/calendar-presets-db';

export function useCalendarPresets() {
  const [presets, setPresets] = useState<CalendarPreset[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const all = await getAllPresets();
      setPresets(all);
    } catch (e) {
      console.error('Failed to load calendar presets', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const save = useCallback(
    async (preset: CalendarPreset) => {
      const saved = await savePreset(preset);
      await refresh();
      return saved;
    },
    [refresh],
  );

  const remove = useCallback(
    async (id: string) => {
      await deletePreset(id);
      await refresh();
    },
    [refresh],
  );

  return { presets, loading, save, remove, refresh };
}
